import { createContext } from 'react';
import type { AppConfigContextType } from '../types/appConfig';

/**
 * Isolated context creation module.
 * Keeping this in a separate file prevents Vite HMR from recreating the context
 * object when AppConfigProvider.tsx is hot-reloaded, which would cause all
 * consumers to see undefined context despite being inside the provider tree.
 */
export const AppConfigContext = createContext<AppConfigContextType | undefined>(undefined);
